// extracted by mini-css-extract-plugin
module.exports = {"modal":"MojosModal_modal__xHbBw","displayMojoFooter":"MojosModal_displayMojoFooter__1te47","mojoImg":"MojosModal_mojoImg__3eEwt","mojoWrapper":"MojosModal_mojoWrapper__29_Qb"};